// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Rq1c","importantInfo":"styles_importantInfo__29q7U"};